export default "__VITE_ASSET__CxC8ej4f__"